<template>
    <div class="page-not-found">
        <div>
            <div>
                <img
                    src="/images/404-decorator.png"
                    alt="Page Not Found"
                    class="page-not-found__decorator"
                />
            </div>
            <div>
                <p class="page-not-found__code">404</p>
                <p class="page-not-found__status">Page Not Found</p>
            </div>
        </div>
        <div>
            <router-link
                tag="button"
                to="/"
                class="btn page-not-found__back"
                >Back Home</router-link
            >
        </div>
    </div>
</template>

<script>
export default {}
</script>
